"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var TrustEventHandlersListCtl = /** @class */ (function (_super) {
    __extends(TrustEventHandlersListCtl, _super);
    function TrustEventHandlersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_evt_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.evt_type_code; });
        _this.dk_evt_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.evt_type_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    TrustEventHandlersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    TrustEventHandlersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "trust handler with id [" + id + "] not found !";
    };
    TrustEventHandlersListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListTrustEventHandlersByBrandIdGet.exec({ all_brands: AllBrands, brand_id_list: BrandIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    title: resp.list[i].title,
                    evt_type_code: resp.list[i].evt_type_code,
                    evt_type_title: resp.list[i].evt_type_title,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    order_number: resp.list[i].order_number,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    TrustEventHandlersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddTrustEventHandler.exec({
            data: {
                brand_id: data.brand_id,
                evt_type_code: data.evt_type_code,
                title: data.title,
                description: data.description,
                order_number: data.order_number,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                title: data.title,
                evt_type_code: data.evt_type_code,
                evt_type_title: resp.evt_type_title,
                description: data.description,
                is_locked: data.is_locked,
                order_number: data.order_number,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    TrustEventHandlersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditTrustEventHandler.exec({
                data: {
                    trust_evt_handler_id: data.key,
                    evt_type_code: data.evt_type_code,
                    title: data.title,
                    description: data.description,
                    order_number: data.order_number,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.description = data.description;
                _tmp.is_locked = data.is_locked;
                _tmp.title = data.title;
                _tmp.order_number = data.order_number;
                _tmp.evt_type_code = data.evt_type_code;
                _tmp.evt_type_title = resp.evt_type_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    TrustEventHandlersListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    TrustEventHandlersListCtl.prototype.DeleteHandler = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteTrustEventHandler.exec({
                data: { trust_evt_handler_id: key }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    TrustEventHandlersListCtl.prototype.doSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetTrustEventHandlerIsLocked.exec({
                data: { trust_evt_handler_id: key, is_locked: isLocked }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    TrustEventHandlersListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetTrustEventHandlerOrderNumber.exec({ data: { trust_evt_handler_id: key, order_number: OrderNumber } }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return TrustEventHandlersListCtl;
}(BaseController_1.BaseController));
exports.TrustEventHandlersListCtl = TrustEventHandlersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/security_trust_handlers/ctl/TrustHandlersListCtl.ts
// module id = 1051
// module chunks = 0